import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { IframeResizer } from "../../utils/iframeResizer";
import * as styles from "./BlackFridayForm.module.scss";

const BlackFridayForm = ({ config }) => {
	const renderedComponent = config.iframeUrl.length > 0 && config.iframeUrl.startsWith("http") && (
		<iframe
			className={cx("fa-iframe", styles.iframeHeight)}
			src={config.iframeUrl}
			frameBorder="0"
			height="0"
			width="100%"
			title={config?.title}
			onLoad={() => {
				IframeResizer(window);
			}}
		/>
	);

	return renderedComponent;
};

BlackFridayForm.propTypes = {
	config: PropTypes.shape({
		iframeUrl: PropTypes.string,
		title: PropTypes.string,
	}).isRequired,
};

export default BlackFridayForm;
export { BlackFridayForm };
